'use client'

import { logError } from '../../Helpers'
import { resolvePlatformEventsUrl } from '../helpers/resolvePlatformEventsUrl'
import { useEffect, useState } from 'react'

export const useBuildPlatformEventsUrl = (scope?: string, code?: string): string | undefined => {
    const [url, setUrl] = useState<string | undefined>(undefined)

    useEffect(() => {
        let isCancelled = false

        const getUrl = async () => {
            const resolvedUrl = await resolvePlatformEventsUrl(scope, code)

            if (!isCancelled) {
                setUrl(resolvedUrl)
            }
        }

        getUrl().catch(() => {
            logError('could not build platform events url', { caller: 'useBuildPlatformEventsUrl' })
        })

        return () => {
            isCancelled = true
        }
    }, [scope, code])

    return url
}
